import { Link, useRouterState } from '@tanstack/react-router';
import { Ellipsis } from 'lucide-react';
import { useState } from 'react';
import { cx } from '@/lib/cx';
import { t } from '@/lib/i18n';
import { pathTo } from '@/lib/search';
import { Sheet } from '@/ui';
import s from './BottomTabs.module.css';
import { InboxBell } from './InboxBell';
import { isActive, useNav } from './nav';

/** Phones: the persona's first four destinations + More (IA §4, §6). */
export function BottomTabs() {
  const { all } = useNav();
  const pathname = useRouterState({ select: (st) => st.location.pathname });
  const [open, setOpen] = useState(false);
  const tabs = all.slice(0, 4);
  const rest = all.slice(4);
  const moreActive = rest.some((i) => isActive(i, pathname, all));

  return (
    <>
      <nav className={s.bar} aria-label={t('Main navigation')}>
        {tabs.map((item) => {
          const active = isActive(item, pathname, all);
          const Icon = item.icon;
          return (
            <Link key={item.key} {...pathTo(item.to)} className={cx(s.tab, active && s.active)} aria-current={active ? 'page' : undefined}>
              <Icon aria-hidden />
              <span>{t(item.label)}</span>
            </Link>
          );
        })}
        <button type="button" className={cx(s.tab, moreActive && s.active)} onClick={() => setOpen(true)} aria-haspopup="dialog">
          <Ellipsis aria-hidden />
          <span>{t('More')}</span>
        </button>
      </nav>
      <Sheet open={open} onOpenChange={setOpen} title={t('More')} side="bottom">
        <div className={s.moreHead}>
          <InboxBell />
        </div>
        <ul className={s.moreList}>
          {all.map((item) => {
            const Icon = item.icon;
            const active = isActive(item, pathname, all);
            return (
              <li key={item.key}>
                <Link {...pathTo(item.to)} className={cx(s.moreItem, active && s.moreActive)} onClick={() => setOpen(false)}>
                  <Icon aria-hidden />
                  <span className={s.moreLabel}>{t(item.label)}</span>
                  {item.planned && <span className={s.soon}>{t('Soon')}</span>}
                </Link>
                {item.children.length > 0 && (
                  <ul className={s.moreChildren}>
                    {item.children.map((c) => (
                      <li key={c.key}>
                        <Link {...pathTo(c.to)} className={s.moreChild} onClick={() => setOpen(false)}>
                          {t(c.label)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </Sheet>
    </>
  );
}
